import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { trendingTopics } from "@/mocks/site";
import { formatViews } from "@/utils/format";

export default function NewsSidebar() {
  const hotArticles = [...articles].sort((a, b) => b.views - a.views).slice(0, 5);
  const tags = Array.from(new Set(articles.flatMap((item) => item.tags))).slice(0, 14);

  return (
    <aside className="space-y-6">
      <section className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-primary-500" aria-hidden="true" />
          热搜榜
        </h2>
        <ol className="mt-4 space-y-3">
          {hotArticles.map((article, index) => (
            <li key={article.id}>
              <Link to={`/article/${article.id}`} className="group flex gap-3">
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                    index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0">
                  <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                    {article.title}
                  </span>
                  <span className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line" aria-hidden="true" />
                    {formatViews(article.views)}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </section>

      <section className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-price-tag-3-line text-secondary-500" aria-hidden="true" />
          热门标签
        </h2>
        <div className="mt-4 flex flex-wrap gap-2">
          {tags.map((tag) => (
            <Link
              key={tag}
              to={`/news?q=${encodeURIComponent(tag)}`}
              className="rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
            >
              #{tag}
            </Link>
          ))}
        </div>
      </section>

      <section className="rounded-lg border border-accent-300 bg-accent-100/70 p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">今日热议</h2>
        <ul className="mt-4 space-y-3">
          {trendingTopics.slice(0, 4).map((topic, index) => (
            <li key={topic.id} className="flex items-start gap-2 text-sm text-foreground-700">
              <span className="mt-0.5 font-heading text-xs font-bold text-accent-700">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="line-clamp-2 leading-snug">{topic.title}</span>
            </li>
          ))}
        </ul>
      </section>
    </aside>
  );
}